// Small helpers shared by the address map providers.

const STATE_ALIASES = { "NCT of Delhi": "Delhi", "Jammu & Kashmir": "Jammu and Kashmir", "Orissa": "Odisha" }

export function normalizeState(name) {
  if (!name) return null
  return STATE_ALIASES[name] || name
}

// Great-circle distance in kilometres.
export function distanceKm(a, b) {
  const rad = (deg) => (deg * Math.PI) / 180
  const dLat = rad(b.lat - a.lat)
  const dLng = rad(b.lng - a.lng)
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2
  return 2 * 6371 * Math.asin(Math.sqrt(h))
}

// Turns Google's Geocoder results for a pin into the fields the address form needs.
// Google returns several results per pin (most specific first) and the postcode or city is often only
// on a less specific one, so each piece is taken from the first result that has it.
export function parseGeocoderResults(results) {
  if (!results || results.length === 0) return null

  const first = results[0]
  const componentIn = (result, type) => result.address_components?.find((c) => c.types.includes(type))?.long_name
  const anywhere = (type) => {
    for (const result of results) {
      const value = componentIn(result, type)
      if (value) return value
    }
    return null
  }

  const street = [
    componentIn(first, "route"),
    componentIn(first, "sublocality_level_2"),
    componentIn(first, "sublocality_level_1") || componentIn(first, "sublocality") || componentIn(first, "neighborhood")
  ]
  const uniqueStreet = [...new Set(street.filter(Boolean))].join(", ")

  return {
    label: first.formatted_address,
    street: uniqueStreet || null,
    city: anywhere("locality") || anywhere("administrative_area_level_3") || anywhere("administrative_area_level_2"),
    state: normalizeState(anywhere("administrative_area_level_1")),
    pincode: (anywhere("postal_code") || "").match(/\d{6}/)?.[0] || null
  }
}
